import { rankingItems } from '@/mocks/homepage';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热门排行
          </h2>
          <p className="text-sm text-foreground-500">
            综合评分、热度与讨论量的实时热门漫画榜单
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          {/* Table Header */}
          <div className="hidden md:grid grid-cols-[60px_1fr_100px_80px_60px] gap-4 px-6 py-3 bg-background-200/50 border-b border-background-200/70 text-xs font-medium text-foreground-500">
            <span>排名</span>
            <span>作品名称</span>
            <span>类型</span>
            <span>评分</span>
            <span>趋势</span>
          </div>

          {rankingItems.map((item, idx) => (
            <div
              key={idx}
              className={`grid grid-cols-1 md:grid-cols-[60px_1fr_100px_80px_60px] gap-2 md:gap-4 px-4 md:px-6 py-4 items-center border-b border-background-200/50 last:border-b-0 hover:bg-background-50 transition-colors duration-200 cursor-pointer ${
                idx === 0 ? 'bg-accent-50/50' : ''
              }`}
            >
              {/* Rank */}
              <div className="flex items-center gap-2">
                <span className={`flex items-center justify-center w-7 h-7 rounded-full text-xs font-bold ${
                  idx === 0 ? 'bg-accent-500 text-background-50' :
                  idx === 1 ? 'bg-secondary-500 text-background-50' :
                  idx === 2 ? 'bg-secondary-400 text-background-50' :
                  'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </span>
                {/* Mobile tag */}
                <span className="md:hidden text-xs font-semibold text-foreground-900">{item.title}</span>
              </div>

              {/* Title (desktop) */}
              <span className="hidden md:block text-sm font-semibold text-foreground-900">{item.title}</span>

              {/* Tag */}
              <span className="hidden md:block">
                <span className="inline-block px-2.5 py-0.5 text-[10px] font-medium rounded-full bg-secondary-100 text-secondary-600">
                  {item.tag}
                </span>
              </span>

              {/* Score */}
              <div className="flex items-center gap-1 text-sm">
                <i className="ri-star-fill text-accent-500 text-xs"></i>
                <span className="font-semibold text-foreground-900">{item.score}</span>
                {/* Mobile meta */}
                <span className="md:hidden text-[11px] text-foreground-400 ml-auto">{item.tag}</span>
              </div>

              {/* Trend */}
              <span className="hidden md:flex justify-center">
                <span className={`flex items-center gap-0.5 text-xs font-medium ${
                  item.trend === 'up' ? 'text-primary-500' : 'text-foreground-400'
                }`}>
                  <i className={`${item.trend === 'up' ? 'ri-arrow-up-line' : 'ri-subtract-line'}`}></i>
                  {item.trend === 'up' ? '上升' : '平稳'}
                </span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}